// לקוח ל-/api/mail/accounts* (20 §1.2): החשבון שלי, חיבור (מחזיר URL של גוגל — ה-drawer "חיבור Gmail" פותח אותו בחלון קופץ,
// או מנווט אליו עם נתיב חזרה; ה-callback חוזר ל-/mail/connected), ניתוק.
import { z } from 'zod';
import { authed, json } from './api.ts';

export const MailCap = z.enum(['send', 'read']);
export type MailCap = z.infer<typeof MailCap>;
export const MailAccount = z.object({
  id: z.string(),
  address: z.string(),
  displayName: z.string().nullable().optional(),
  caps: z.array(MailCap),
  status: z.enum(['ok', 'reauth_required', 'error']),
  lastError: z.string().nullable().optional(),
  createdAt: z.string(),
});
export type MailAccount = z.infer<typeof MailAccount>;
/** readEnabled (21 §3): חיבור לקריאה (gmail.readonly) פתוח במופע — כבוי כברירת מחדל. */
const Mine = z.object({ configured: z.boolean(), readEnabled: z.boolean().optional().default(false), account: MailAccount.nullable() });
export type MailMine = z.infer<typeof Mine>;
const ConnectUrl = z.object({ url: z.string() });

export const mailApi = {
  mine: () => json(Mine, '/api/mail/accounts/mine'),
  /** popup — החלון הקופץ מודיע ונסגר; returnTo — חזרה באותה לשונית (כשהחלון נחסם). */
  connectUrl: (caps: MailCap[], o: { popup?: boolean; returnTo?: string } = {}) => {
    const q = new URLSearchParams({ caps: caps.join(',') });
    if (o.popup) q.set('popup', '1');
    if (o.returnTo) q.set('return', o.returnTo);
    return json(ConnectUrl, `/api/mail/accounts/connect?${q}`);
  },
  disconnect: () => authed('/api/mail/accounts/mine', { method: 'DELETE' }).then(() => undefined),
};

/** האם החשבון מחובר ותקין לכל ה-caps. */
export const hasCaps = (a: MailAccount | null | undefined, caps: MailCap[]) => !!a && a.status === 'ok' && caps.every((c) => a.caps.includes(c));
